import { withPrometheusMetricsGetServerSideProps } from '@jusbrasil-web/core-next'
import { BlogPage, BlogPageExports } from '@jusbrasil-web/docview/publications'

const { getServerSideProps: getServerSidePropsRaw } = BlogPageExports
const getServerSideProps = withPrometheusMetricsGetServerSideProps(
  __filename,
  getServerSidePropsRaw
)
export { getServerSideProps }
export default BlogPage
